const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case "levelEvaluations/SET_LEVEL_EVALUATIONS":
      return {
        ...state,
        [action.companyUUID]: {
          ...state[action.companyUUID],
          results: action.payload,
        },
      }
    case "levelEvaluations/SET_LOADING":
      return {
        ...state,
        [action.companyUUID]: {
          ...state[action.companyUUID],
          loading: action.payload,
        },
      }
    case "levelEvaluations/SET_ERROR":
      return {
        ...state,
        [action.companyUUID]: {
          ...state[action.companyUUID],
          error: action.payload,
        },
      }
    case "LOGOUT":
      return initialState
    default:
      return state
  }
}
